// src/pages/ContactPage.tsx
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactForm from '../components/ContactForm';

function ContactPage() {
  return (
    <div className="layout-container">
      <div className="container">
        <Header />
        <main>
          <section
            style={{
              padding: "64px 0",
              minHeight: "60vh",
              display: "flex",
              alignItems: "center"
            }}
          >
            <div style={{ maxWidth: 860, margin: "0 auto" }}>
              <h1 className="text-3xl font-semibold mb-4">Contact PrintQR</h1>
              <p className="text-sm text-neutral-700 mb-8">
                Questions about Pro licensing, billing, or feature ideas? Drop a note here and we’ll
                follow up by email. No spam, ever.
              </p>
              <div
                style={{
                  border: "1px solid var(--border)",
                  borderRadius: "0.75rem",
                  padding: "16px",
                  background: "transparent",
                }}
              >
                <ContactForm />
              </div>
            </div>
          </section>
        </main>
      </div>
      <Footer />
    </div>
  );
}

export default ContactPage;
export { ContactPage };
